import { get, throttle } from 'lodash';
import { format } from 'utils';
import {
  fetchVideo,
  destroyVideo,
  selectVideo,
  updateVideo,
} from 'logic/videoResume';

export const VideoPlayerResumable = {
  bindings: {
    autoplay: '<',
    totalTime: '<',
    videoId: '<',
    onLoad: '&',
    onComplete: '&',
  },

  template: `
    <div class="video-player-resumable">
      <div ng-show="$ctrl.showResume">
        <a class="btn btn-resume text-white" ng-click="$ctrl.resumeVideo()">
          <i class="fa fa-play mr-1"></i> Resume video?
        </a>
      </div>
      <video-player
        video-id="$ctrl.videoId"
        on-load="$ctrl.onLoadPlayer(player)">
      </video-player>
    </div>`,

  controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(
          this.mapState.bind(this),
          this.mapDispatch()
        );

        this.unsubscribe = connect(this);
        this.fetchVideo();
      },

      $onChanges(changes) {
        if (
          changes.videoId &&
          changes.videoId.currentValue &&
          this.fetchVideo
        ) {
          this.fetchVideo();
        }
      },

      $onDestroy() {
        if (this.player) {
          this.player.off('ended');
          this.player.off('play');
          this.player.off('timeupdate');
        }

        this.isActive = false;
        this.unsubscribe();
      },

      mapDispatch() {
        return {
          destroyVideo,
          fetchVideo,
          updateVideo,
        };
      },

      mapState(state) {
        return {
          currentTime: selectVideo(state.videoResume, this.videoId),
        };
      },

      onLoadPlayer(player) {
        $timeout(() => {
          this.player = player;
          this.showResume = this.currentTime > 0;
          this.isActive = true;

          this.player.on('play', () => this.onPlay());
          this.player.on('ended', () => this.onEnded());
          this.player.on(
            'timeupdate',
            throttle(() => this.onTimeupdate(), 1000)
          );

          this.onLoad({ player });
        });
      },

      onPlay() {
        this.showResume = false;
      },

      onTimeupdate() {
        if (this.isActive && this.player.remainingTime()) {
          this.updateVideo(this.videoId, Math.floor(this.player.currentTime()));
        }
      },

      onEnded() {
        this.destroyVideo(this.videoId);
      },

      resumeVideo() {
        // https://github.com/videojs/video.js/issues/4696
        const hackySafariFix = () => {
          this.player.off('canplay');
          this.player.currentTime(this.currentTime);
        };

        this.player.on('canplay', () => hackySafariFix());
        this.player.currentTime(this.currentTime);
        this.player.play();
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Video/VideoPlayerResumable.js